import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { Button } from "@marekl/adminer/components";
import styles from "./JsonBlock.module.css";

interface JsonBlockProps {
  /** Raw JSON string from the wire (pretty-printed when parseable). */
  json: string | undefined | null;
  /** Collapsible header label; without it the block renders expanded. */
  label?: string;
  defaultOpen?: boolean;
}

function pretty(raw: string): string {
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}

/** Pretty-printed JSON in a mono <pre>, optionally collapsible. */
export function JsonBlock({ json, label, defaultOpen = false }: JsonBlockProps) {
  const [open, setOpen] = useState(defaultOpen);
  if (!json) return null;
  const body = <pre className={styles.pre}>{pretty(json)}</pre>;
  if (!label) return body;
  return (
    <div>
      <Button
        size="sm"
        weight="ghost"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        startIcon={
          open ? (
            <ChevronDown size={14} aria-hidden="true" />
          ) : (
            <ChevronRight size={14} aria-hidden="true" />
          )
        }
      >
        {label}
      </Button>
      {open && body}
    </div>
  );
}
